import { type SizeProps } from '../../types/sizes';
import { FullyConstrainedSize } from '../structural/FullyConstrainedSize';
import { Stack, type StackProps } from '../structural/Stack';

export interface AppRootProps extends Omit<StackProps, 'direction' | 'overflow' | SizeProps> {}

export const AppRoot = ({ children, ...props }: AppRootProps) => (
  <FullyConstrainedSize
    {...props}
    component={Stack}
    direction='column'
    height='100vh'
    width='100vw'
  >
    {children}
  </FullyConstrainedSize>
);
